import { refreshAuth } from "app/requests";
import { setApiLoader } from "app/store/state/admin/action";
import { loaderFlag, setPopUpMessageData } from "app/store/state/jobs/action";
import { getItem, resetSession, setItem } from "app/utils/session";
import axios from "axios";
import get from "lodash/get";
import { configData } from '../utils/config';
import { isEqual, splitStr } from "app/utils/javascript";
import { languageFn } from "app/common/components/customFunction";

export const Service = (requestAttr) => {
    const { APP_NAME, country } = configData;
    const language = getItem("lang")
    const authToken = getItem("token")
    let headerData = {
        'APP_NAME': APP_NAME,
        'country': country,
        'Accept-language': languageFn(language), ...configData?.authorization
    };
    return new Promise((resolve, reject) => {
        const { data, ...restRequestAttr } = requestAttr;
        if (restRequestAttr?.header) {
            headerData["AUTH-TOKEN"] = restRequestAttr.header?.AUTH_TOKEN
            delete restRequestAttr.header
        }
        if (restRequestAttr?.headers) {
            headerData["Authorization"] = restRequestAttr.headers?.Authorization
            delete restRequestAttr.headers
        }
        const resultAttr = { ...restRequestAttr, withCredentials: true };
        const validation = data?.authToken === undefined ? data?.get('authToken') ? true : false : data?.authToken ? true : false;
        if (validation) {
            axios({
                ...resultAttr,
                data,
                headers: { ...headerData, 'Authorization': `Bearer ${authToken}` },
            })
                .then((res) => {
                    const errorCode = get(res, "data.error.errorCode");
                    const errorMsg = get(res, "data.error.errorMsg");
                    window.redux(setApiLoader(false))

                    if (errorCode === 32) {
                        refreshAuth().then((res) => {
                            const refreshedTokens = get(res, "data.data", {});
                            const refreshTokenErrorMsg = get(res, "data.error.errorMsg");
                            if (refreshTokenErrorMsg) {
                                resetSession()
                            } else {
                                const { authToken, refreshToken } = refreshedTokens;
                                setItem("token", authToken);
                                setItem("refresh_token", refreshToken);
                                data.authToken = authToken;

                                axios({
                                    ...resultAttr, data,
                                    headers: { ...headerData, ...configData?.authorization }
                                })
                                    .then((r) => resolve(r))
                                    .catch((err) => {
                                        reject(err);
                                    });
                            }
                        }).catch((err) => {
                            resetSession()
                        });
                    } else {
                        if (errorMsg) {
                            window.redux(loaderFlag(false))
                            const newUrl = splitStr(requestAttr?.url, "com")
                            if (isEqual(newUrl?.[1], "/device/api/rs/web/v1/service/update/user/tool") && ((isEqual(requestAttr?.method, "delete") && isEqual(errorCode, 423)) || (isEqual(requestAttr?.method, "post") && isEqual(errorCode, 430)))) {
                                window.redux(setPopUpMessageData({ modal: true, message: [errorMsg], deleteCylinderId: requestAttr?.data?.id, method: requestAttr?.method }))
                            } else {
                                window.redux(setPopUpMessageData({ modal: true, message: [errorMsg], }))
                            }
                        }
                        resolve(res);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        }
    });
};
